module.exports = __webpack_public_path__ + "static/assets/07a46bdc548acccfa4a6efd25516280c.svg";